import React from 'react';
import { useAtom } from 'jotai';
import { businessTypeAtom, visibleBusinessAtom } from '@/store';
import Modal from '../modal';
import BusinessCard from '@/assets/image/team/business-card.png';
import BusinessCardCommercial from '@/assets/image/new/business-code.png';
import { BusinessType } from '@/constants/subscription';

import styles from './index.module.css';

const BusinessModal = () => {
  const [visibleBusiness, setVisibleBusiness] = useAtom(visibleBusinessAtom);
  const [businessType] = useAtom(businessTypeAtom);

  return (
    <Modal
      visible={visibleBusiness}
      onClose={() => setVisibleBusiness(false)}
      style={{
        width: '338px',
        height: '338px',
      }}
    >
      <div className={styles.body}>
        <div className={styles.title}>
          {businessType === BusinessType.LargeAmount
            ? '大额订单或支付失败请扫码联系商务处理'
            : '咨询企业商用'}
        </div>
        <img
          src={businessType === BusinessType.LargeAmount ? BusinessCard : BusinessCardCommercial}
          alt=""
          className={styles.img}
        />
      </div>
    </Modal>
  );
};

export default React.memo(BusinessModal);
